module.exports = __webpack_public_path__ + "static/media/dashboard-1.f0547746.svg";